import {
  Dropdown as FluentDropdown,
  DropdownProps as FluentDropdownProps,
  useFieldContext_unstable,
} from '@fluentui/react-components';
import React, { forwardRef } from 'react';
import { useInputAppearance } from '../hooks';

export type DropdownProps = FluentDropdownProps;

/**
 * Themed Dropdown wrapper that automatically applies the correct
 * filled appearance based on the current theme (dark/light).
 * The appearance can still be overridden via props.
 */
export const Dropdown = forwardRef<HTMLButtonElement, DropdownProps>(
  ({ appearance, ...props }, ref) => {
    const themedAppearance = useInputAppearance();
    // Fluent v9 Field associates the label via <label htmlFor> and skips aria-labelledby
    // when supportsLabelFor is true. Forward labelId explicitly so the trigger button has
    // the same aria-labelledby reference Northstar used to generate.
    const fieldContext = useFieldContext_unstable();
    const ariaLabelledBy = props['aria-labelledby'] ?? fieldContext?.labelId;

    return (
      <FluentDropdown
        ref={ref}
        appearance={appearance ?? themedAppearance}
        aria-labelledby={ariaLabelledBy}
        {...props}
      />
    );
  },
);

Dropdown.displayName = 'Dropdown';
